import BaseService from './base.service';

class FileDownloadService extends BaseService{

    async download(url, name, options){
        const resp = await fetch(url, options);
        this.handleHttpErrors(resp);
        const blob = await resp.blob();
        let objUrl = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = objUrl;
        if ( name ) {
            a.download = name;
        }
        else{
            const contentDisposition = resp.headers.get('content-disposition')
            const idx = contentDisposition.indexOf("filename=")
            const fileName = contentDisposition.substr(idx+9).replace(/"/g,'')
            a.download = fileName
        }
        a.click();
    }
}

const fileDownloadService = new FileDownloadService();

export default fileDownloadService;